<template>
  <div class="visualrecognitiondetailview">
      <a href="/app/secure/visualrecognition/" class="btn btn-close">Close</a>
    <div class="card p-0">
      <!-- <div class="heading card-heading">Visual Inspection</div> -->
      <div class="card-body">
        <div class="row m-0">
          <div class="col-3 form-group">
            <label for="id_commodity" class="label">Commodity</label>
            <select
              name="selectedCommodity"
              class="form-control"
              v-model="selectedCommodity"
              required
              placeholder="Select one"
              id="id_commodity"
              :disabled="this.viewMode || this.reportSubmitted"
            >
              <option v-for="iType in this.commodities" :key="iType" :value="iType">{{iType}}</option>
              <!-- <option value="Bulk">Bulk</option>
                    <option value="Received Packed">Received Packed</option>
                    <option value="Pack Line">Pack Line</option>
              <option value="Shipping">Shipping</option>-->
            </select>
          </div>
          <div class="col-3 form-group">
            <label for="id_date" class="label">Inspection Date</label>
            <datepicker
              ref="id_date"
              format="MM/dd/yyyy"
              id="id_date"
              v-if="!viewMode"
              v-model="inspection_date"
              class="form-control datepicker"
              required
              placeholder="Select date"
              @change="changeFilterValue"
              :disabled="this.viewMode || this.reportSubmitted"
            ></datepicker>
            <datepicker
              ref="id_date"
              format="MM/dd/yyyy"
              id="id_date"
              v-else
              v-model="report_inspection_date"
              class="form-control datepicker"
              required
              placeholder="Select date"
              @change="changeFilterValue"
              :disabled="this.viewMode || this.reportSubmitted"
            ></datepicker>

            <span class="datepicker-icon">
              <span
                style="background-color: #24C656;border-top-right-radius: 4px;padding-top:10px;padding-bottom:12px;"
                @click="calendarClick"
              >
                <img src="@/assets/images/cal.svg" alt style="padding: 12px 09px;" />
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row m-0" v-if="selectedCommodity || viewMode">
      <div class="col-12 col-md-6">
        <div class="heading pl-0">Inspect Image</div>
        <div :class="`upload-image-card ${!(this.viewMode ||this.reportSubmitted) && 'placeholder'}`"  @drop.prevent="uploadImage" @dragover.prevent>
          <div class="upload-image-placeholder" v-if="!this.viewMode && !this.reportSubmitted" >
            <img class="upload-image-icon" src="@/assets/icons/imageDrag.svg" alt />
          </div>
          <div class="image-upload" v-else>
            <v-lazy-image :src="url" src-placeholder="@/assets/icons/imageDrag.svg"
   class="uploaded-image" alt />
          </div>
        </div>

        <button class="btn upload-image-btn" @click="UploadBtnClicked" v-if="!this.viewMode && !this.reportSubmitted">
          <span>upload Image</span>
        </button>
      </div>
      <div class="col summary-container" v-if="this.viewMode || this.reportSubmitted">
        <div class="heading pl-0">Inspection Summary</div>
        <div class="summary-table-container">
          <table class="table summary-table">
            <tbody>
              <tr>
                <td colspan="1" class="col-head">Count</td>
                <td colspan="1" class="col-head"></td>
                <!-- <td colspan="1" class="col-head"></td> -->
              </tr>
              <tr>
                <td>{{count}}</td>
                <td></td>
                <!-- <td></td> -->
              </tr>
              <tr>
                <td colspan="2" class="section-head">Size Profile</td>
              </tr>

              <tr>
                <td colspan="1" class="col-head">Count</td>
                <td colspan="1" class="col-head">Size</td>
                <!-- <td colspan="1" class="col-head"></td> -->
              </tr>
              <tr v-for="(item,key) in sizeProfile" :key="key">
                <td>{{key}}</td>
                <td>{{(Math.round(item*100)/100)}}inches</td>
                <!-- <td></td> -->
              </tr>
              <tr>
                <td colspan="2" class="section-head">External Defects</td>
              </tr>

              <tr>
                <td colspan="1" class="col-head">Defect Name</td>
                <td colspan="1" class="col-head">Percentage of Defect</td>
                <!-- <td colspan="1" class="col-head">def3</td> -->
              </tr>
              <tr v-for="(item,key) in extDefect" :key="key">
                <td>{{key}}</td>
                <td>{{(Math.round((item.slice(0,-3))*100)/100)}}</td>
                <!-- <td>c</td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./VisualRecognitionDetailView.scss";
import Datepicker from "vuejs-datepicker";
import VLazyImage from "v-lazy-image";
export default {
  components: {
    Datepicker,
    VLazyImage
  },
  data() {
    return {
      selectedCommodity: this.viewMode ? this.$route.params.commodity : "",
      inspection_date: new Date(),
      reportSubmitted: false
      //   image: true
    };
  },
  computed: {
    commodities() {
      return this.$store.state.VisualAnalysis.commodities;
    },
    viewMode() {
      return this.$route.path.toLowerCase().includes("/view/");
    },
    commodity() {
      return this.$route.params.commodity;
    },
    report_inspection_date() {
      return this.$store.state.VisualAnalysis.report != {}
        ? new Date(this.$store.state.VisualAnalysis.report.inspection_date)
        : new Date();
    },
    id() {
      return this.viewMode
        ? this.$route.params.id
        : this.$store.state.VisualAnalysis.report != {}
        ? this.$store.state.VisualAnalysis.report.id
        : "";
    },
    url() {
      return this.$store.state.VisualAnalysis.report != {}
        ? this.$store.state.VisualAnalysis.report.url
        : "";
    },
    count() {
      return this.$store.state.VisualAnalysis.report != {}
        ? this.$store.state.VisualAnalysis.report.report["count of potatoes"]
        : "";
    },
    extDefect() {
      return this.$store.state.VisualAnalysis.report != {}
        ? this.$store.state.VisualAnalysis.report.report[
            "external defect percentage"
          ]
        : {};
    },
    sizeProfile() {
      return this.$store.state.VisualAnalysis.report != {}
        ? this.$store.state.VisualAnalysis.report.report["sizing profile"]
        : {};
    }
  },
  methods: {
    calendarClick() {
      this.$refs.id_date.showCalendar();
    },
    UploadBtnClicked() {
      var input = document.createElement("input");
      input.type = "file";
      input.setAttribute("accept", "image/jpeg");
      input.setAttribute("multiple", "");
      var files = [];

      input.onchange = async e => {
        this.$store.dispatch("showLoader", true);
        files = e.target.files;
        if (files.length !== 1) {
          return this.$store.commit("showSnackbar", {
            msg: "Only one image is allowed at a time!"
          });
        }
        let file = files[0];
        if (!file.type.includes("image"))
          return this.$store.commit("showSnackbar", {
            msg: "Only image is allowed!"
          });
        this.$store.dispatch("uploadVisualAnalysisReport",{commodity:this.selectedCommodity,inspection_date:this.inspection_date,file}).then(()=>{
        this.reportSubmitted=true 
      });
      };
      input.click();
    },
    uploadImage(e) {
      let files = e.dataTransfer.files
      
      if (files.length !== 1) {
        return this.$store.commit("showSnackbar", {
          msg: "Only one image is allowed at a time!"
        });
      }
      let file = files[0];
      if (!file.type.includes("image"))
        return this.$store.commit("showSnackbar", {
          msg: "Only image file is allowed!"
        });
      this.$store.dispatch("uploadVisualAnalysisReport",{commodity:this.selectedCommodity,inspection_date:this.inspection_date,file}).then(()=>{
        
        this.reportSubmitted=true
      });
    }
  },
  mounted() {
    if (this.viewMode)
      this.$store.dispatch("getVisualAnalysisReport", {
        commodity: this.commodity,
        id: this.id
      });
    else {
      this.$store.commit("getVisualAnalysisReport", {});
      this.$store.commit("showLoader", false);
    }
    this.selectedCommodity= this.$route.params.commodity
    this.$store.dispatch("getVisualAnalysisCommodities");
  },
  created(){
    if (!this.viewMode)
    this.$store.commit("changePathLabel", {
        view: "Autonomous Inspection",
        categories: [
          { name: "Powered by AI", focus: false },
          { name: "New Inspection", focus: true }
        ]
      });
    else  
    this.$store.commit("changePathLabel", {
        view: "Autonomous Inspection",
        categories: [
          { name: "Powered by AI", focus: false },
          { name: "View Inspection", focus: true }
        ]
      });
  }
};
</script>

<style>
</style>